import bem from 'utils/bem';

export const block = bem('privacy-policy-message');
